<template>
	<div id="class" class="columns">
		<div class="column">
			<div class="card">
				<header class="card-header">
					<section class="card-header-title">
						<h4 class="title is-4">Mijn Klas</h4>
					</section>
				</header>
				<header class="card-header" style="background-color:#eeeeee;">
					<section>
						<div class="level" style="background-color:#eeeeee;">
							<div class="level-left">
								<div class="level-item" style="padding:10px;">
									<b-field label="Testgroep:" horizontal>
										<b-select
											size="is-normal"
											@change="getSelectedClass()"
											v-model="selected_class"
											filterable
											placeholder="Kies ..."
										>
											<option
												v-for="item in classes"
												:key="item.value"
												:value="item.value"
											>Groep {{item.label}}</option>
										</b-select>
									</b-field>
								</div>
							</div>
						</div>
					</section>
				</header>
				<div style="padding:5px;">
					<b-table
						:data="studentData"
						:bordered="false"
						:narrowed="true"
						:striped="true"
						:loading="loading"
						:paginated="isPaginated"
						:per-page="perPage"
						:current-page.sync="currentPage"
						:pagination-simple="isPaginationSimple"
						:default-sort-direction="defaultSortDirection"
					>
						<template slot-scope="props">
							<b-table-column width="40" v-show="currentschoolyear.appeal == false">
								<a class="button is-small is-warning" @click="handleClick(props.row.student_id)">
									<!-- <i class="fas fa-edit"></i> -->
									<span>OWKR Invullen</span>
								</a>
							</b-table-column>
							<b-table-column width="40" v-show="currentschoolyear.appeal">
								<a class="button is-small is-warning" @click="set_inberoep(props.row.student_id, true)">
									<span>
										Ouder gaat in
										<strong>beroep</strong>
									</span>
								</a>
							</b-table-column>
							<b-table-column
								label="Ouder gaat in beroep"
								field="tbl_student.tbl_further_education.appeal_result"
								centered
							>
								<template v-if="props.row.tbl_student.tbl_further_education">
									<b-checkbox
										size="is-small"
										v-model="props.row.tbl_student.tbl_further_education.appeal_result"
										@change.native="set_inberoep(props.row.student_id,props.row.tbl_student.tbl_further_education.appeal_result)"
									></b-checkbox>
								</template>
								<template v-else>
									<b-checkbox size="is-small"></b-checkbox>
								</template>
							</b-table-column>

							<b-table-column
								label="Leerlingnr"
								field="student_number"
								centered
							>{{ props.row.student_number }}</b-table-column>
							<b-table-column
								label="Achternaam"
								field="tbl_student.surname"
							>{{ props.row.tbl_student.surname }}</b-table-column>
							<b-table-column
								label="Voornaam"
								field="tbl_student.firstname"
							>{{ props.row.tbl_student.firstname }}</b-table-column>
							<template v-if="props.row.tbl_student.tbl_sys_gender!= null">
								<b-table-column
									label="Geslacht"
									field="tbl_student.tbl_sys_gender.name"
								>{{ props.row.tbl_student.tbl_sys_gender.name }}</b-table-column>
							</template>
							<template v-else>
								<b-table-column label="Geslacht" field></b-table-column>
							</template>
							<b-table-column
								label="ID"
								field="tbl_student.governement_id"
								width="125"
							>{{ props.row.tbl_student.governement_id }}</b-table-column>
						</template>

						<template slot="empty">
							<section class="section">
								<div class="content has-text-grey has-text-centered">
									<p>
										<b-icon icon="exclamation" size="is-large"></b-icon>
									</p>
									<p>Nothing here.</p>
								</div>
							</section>
						</template>
					</b-table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Axios from "axios";
//import Icon from "vue-awesome/components/Icon.vue";
import Cookies from "js-cookie";
//
import { API_ROOT } from "../config";

var instance = Axios.create({
	baseURL: API_ROOT,
	timeout: 60000
});

export default {
	name: "class",
	created: function() {
		if (_.isUndefined(this.access == 0)) {
			this.$router.push({
				path: "/"
			});
		}
		this.getClasses();
		this.$store.dispatch("resetloading");
		this.getCurrentschoolyear();
	},
	data: function() {
		return {
			access: Cookies.get("access"),
			user: Cookies.getJSON("user"),
			classes: [],
			selected_class: "",
			inberoep: false,
			studentData: [],
			currentschoolyear: {},
			loading: false,
			isEmpty: false,
			isPaginated: true,
			isPaginationSimple: false,
			defaultSortDirection: "asc",
			currentPage: 1,
			perPage: 12
		};
	},
	watch: {
		selected_class(val) {
			self = this;
			//todo:
			this.loading = true;
			instance.get("/student-class/students/" + val).then(function(response) {
				console.log(response.data.data);

				self.studentData = response.data.data;
				self.loading = false;
			});
		}
	},
	computed: {
		// user() {
		//   return this.$store.getters.getUser;
		// },
		// loggedin() {
		//   return this.$store.getters.getLoggedin;
		// }
	},
	methods: {
		set_inberoep(id, appeal_result) {
      console.log(id);
      console.log(appeal_result);

			instance
				.post("/further-education-update", {
					student_id: id,
					appeal_result: appeal_result
				})
				.then(function(response) {
          //console.log(response.data.data);
          self.getSelectedClass();
				});
		},
		getCurrentschoolyear() {
			var self = this;

			instance.get("/current-schoolyear").then(function(response) {
				console.log(response.data.data);

				self.currentschoolyear = response.data.data;
			});
		},
		handleEdit(index, row) {
			console.log(index, row);
		},
		handleClick_Inberoep(studentid) {
			this.$router.push({
				path: "/studentberoep/" + studentid
			});
		},
		handleClick(studentid) {
			console.log("studentid: " + studentid);
			console.log(this.user);

			switch (this.user.tbl_sys_role.id) {
				case 2:
				case 1:
					this.$router.push({
						path: "/student/" + studentid
					});
					break;
				case 5:
					break;
				default:
					break;
			}
		},
		reexamClick(studentid) {
			console.log("studentid: " + studentid);

			this.$router.push({
				path: "reexam/" + studentid
			});
		},
		handleDelete(index, row) {
			console.log(index, row);
		},
		onPagination: function() {},
		getSelectedClass: function() {
			console.log(this.selected_class);
			self = this;
			//todo:
			this.loading = true;
			instance
				.get("/student-class/students/" + this.selected_class)
				.then(function(response) {
					console.log(response.data.data);

					self.studentData = response.data.data;
					self.loading = false;
				});
		},
		getClasses: function() {
			var self = this;
			//console.log(this.selected_class);
			this.params = this.$route.params;
			console.log(this.$route);
			console.log("user");
			console.log(this.user);
			//todo:
			instance
				.get("/user-class/classes/" + this.user.user_id)
				.then(function(response) {
					var obj = response.data.data;
					console.log("Classes returned: " + obj.length);
					console.log(obj);

					for (var classes in obj) {
						console.log("Class ID: " + obj[classes].class_id);
						if (obj.hasOwnProperty(classes)) {
							self.classes.push({
								value: obj[classes].class_id,
								key: obj[classes].class_id,
								label: obj[classes]["tbl_conf_class.testgroup"]
							});
						}
					}

					console.log("Pre select: " + obj[0].class_id);
					self.selected_class = obj[0].class_id;
					self.getSelectedClass();
				});
		}
	}
};
</script>
<style scoped>
</style>
